import { Suspense, useState } from "react";
import { Outlet } from "react-router";
import { useAuth } from "@/lib/auth-context";
import { UserMenu } from "@/components/shared/user-menu";
import { RouteFallback } from "@/components/shared/route-fallback";
import { AdminSidebar } from "./admin-sidebar";
import { GlobalSearch } from "./global-search/global-search";

// Ports /app/admin/layout.tsx + /components/admin/TopBar.tsx. The sidebar
// search pill and ⌘K shortcut both drive the GlobalSearch command palette.
export function AdminLayout() {
  const { session } = useAuth();
  const [searchOpen, setSearchOpen] = useState(false);
  if (!session) return null; // ProtectedRoute already gates this, but Outlet won't render without a session

  return (
    <div className="flex min-h-screen bg-background">
      <AdminSidebar
        permissions={session.permissions}
        onOpenSearch={() => setSearchOpen(true)}
      />
      <GlobalSearch
        open={searchOpen}
        onOpenChange={setSearchOpen}
        permissions={session.permissions}
      />
      <div className="flex min-w-0 flex-1 flex-col">
        <header className="sticky top-0 z-30 flex h-14 items-center justify-end gap-4 border-b bg-background/80 px-6 backdrop-blur supports-[backdrop-filter]:bg-background/60">
          <UserMenu email={session.email} fullName={session.fullName} role="internal" />
        </header>
        <main className="flex-1 px-6 py-6 md:px-8 md:py-8">
          <Suspense fallback={<RouteFallback />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  );
}
